export default "<tln-manuscript-view></tln-manuscript-view>\n\n"